import React from 'react';
import { Typography, Menu, MenuItem, Avatar } from '@material-ui/core';
import { useDispatch } from 'react-redux';

import { Box } from 'components';
import {
  AvatarImg,
  ProfileIcon,
  // SettingsIcon,
  LogoutIcon,
  referAndEarnIcon,
} from 'assets';
import history from 'common/utils/history';
import { handleSignOut } from 'redux-modules/auth/Actions';

import styles from './styles';

type Props = {
  name: string;
};

const PageHeader = ({ name }: Props) => {
  const dispatch = useDispatch();
  const classes = styles();

  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSignOutButton = () => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    window.Intercom('shutdown');
    dispatch(handleSignOut());
  };

  return (
    <Box className={classes.headerBox}>
      <Typography gutterBottom className={classes.userNameHeaderText}>
        {name}
      </Typography>
      <Box>
        <Avatar
          aria-controls="simple-menu"
          aria-haspopup="true"
          onClick={handleClick}
          alt={AvatarImg}
          src={AvatarImg}
          className={classes.avatarImg}
        />
        <Menu
          id="simple-menu"
          anchorEl={anchorEl}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          keepMounted
          open={Boolean(anchorEl)}
          onClose={handleClose}
          className={classes.avatarMenu}
        >
          <MenuItem
            onClick={() => {
              history.push('/profile');
              handleClose();
            }}
          >
            <img
              src={ProfileIcon}
              alt={ProfileIcon}
              className={classes.menuIcon}
            />
            Profile{' '}
          </MenuItem>
          {/* <MenuItem
            onClick={() => {
              history.push('/settings');
              handleClose();
            }}
          >
            <img
              src={SettingsIcon}
              alt={SettingsIcon}
              className={classes.menuIcon}
            />{' '}
            Settings
          </MenuItem> */}
          <MenuItem
            onClick={() => {
              history.push('/refer');
              handleClose();
            }}
          >
            <img
              src={referAndEarnIcon}
              alt={referAndEarnIcon}
              className={classes.menuIcon}
            />
            Refer & Earn
          </MenuItem>
          <MenuItem
            onClick={() => {
              handleSignOutButton();
              handleClose();
            }}
          >
            <img
              src={LogoutIcon}
              alt={LogoutIcon}
              className={classes.menuIcon}
            />
            Log Out
          </MenuItem>
        </Menu>
      </Box>
    </Box>
  );
};

export default PageHeader;
